// extracted by mini-css-extract-plugin
export default {"root":"_2Acnz","text-block":"_2sDyX","textBlock":"_2sDyX","prefix":"WkXt3"};